"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Displays a status message. Use this for things like inline validation errors or success messages.
 */
var InlineStatus = function InlineStatus(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      status = _ref.status,
      cssModule = _ref.cssModule,
      attrs = _objectWithoutProperties(_ref, ["id", "className", "children", "status", "cssModule"]);

  var classes = (0, _mapToCssModules.default)((0, _classnames.default)(className, 'status-msg', _defineProperty({}, "status-msg--".concat(status), !!status)), cssModule);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, attrs, {
    className: classes,
    id: id
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _mapToCssModules.default)('status-msg__message', cssModule)
  }, children));
};

InlineStatus.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
  status: 'error',
  cssModule: undefined
};
InlineStatus.propTypes = {
  /**
   * Useful for associating
   */
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  /**
   * A description of the prop, it will automatically appear in the docs
   */
  status: _propTypes.default.oneOf(['error', 'success', 'warning', 'info']),
  cssModule: _propTypes.default.object
};
var _default = InlineStatus;
exports.default = _default;
//# sourceMappingURL=InlineStatus.js.map